/**
 * @desc directive to update the styling of an element outside the Angular app
 * @example <update-style element="" class=""></update-style>
 */

function updateStyle() {
  return {
    restrict: 'E',
    scope: {
      element: '@',
      class: '@'
    },
    link(scope, element) {
      const itemToUpdate = angular.element(document).find(scope.element);

      itemToUpdate.addClass(scope.class);

      element.on('$destroy', () => {
        itemToUpdate.removeClass(scope.class);
      });
    }
  };
}

export default function (ngModule) {
  ngModule.directive('updateStyle', updateStyle);
}
